var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Fairs"}},[_c('SimpleSlider',{attrs:{"img":"/images/fairs/slide.webp"}}),_c('InnovativeTechnology'),_c('SystemDesign'),_c('RegistrationFlexibility'),_c('AccessManagement'),_c('LeadTrackingSystem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }